import Action from 'redux/helpers/createAction'
const name = 'competitors'

export const loadCompetitorOverview = Action(
  name + '/LOAD_COMPETITOR_OVERVIEW_DATA',
  (domainId, filters) => ({
    domainId,
    filters
  })
)
export const loadCompetitorOverviewSuccess = Action(
  name + '/LOAD_COMPETITOR_OVERVIEW_DATA_SUCCESS',
  data => ({
    data
  })
)
export const loadCompetitorOverviewFailure = Action(
  name + '/LOAD_COMPETITOR_OVERVIEW_DATA_FAILURE',
  error => ({
    error
  })
)

export const getCompetitorHistory = Action(
  name + '/GET_COMPETITOR_HISTORY_DATA',
  (domainId, keywordId, filters) => ({
    domainId,
    keywordId,
    filters
  })
)
export const getCompetitorHistorySuccess = Action(
  name + '/GET_COMPETITOR_HISTORY_DATA_SUCCESS',
  (domainId, keywordId, data) => ({
    domainId,
    keywordId,
    data
  })
)
export const getCompetitorHistoryFailure = Action(
  name + '/GET_COMPETITOR_HISTORY_DATA_FAILURE',
  error => ({
    error
  })
)

export const deleteCompetitor = Action(name + '/DELETE_COMPETITOR', (domainId, competitorId) => ({
  domainId,
  competitorId
}))

export const deleteCompetitorSuccess = Action(name + '/DELETE_COMPETITOR_SUCCESS')

export const deleteCompetitorFailure = Action(name + '/DELETE_COMPETITOR_FAILURE', error => ({
  error
}))

export const exportDomainKeywordCompetitorsExcel = Action(
  name + '/EXPORT_DOMAIN_KEYWORD_COMPETITORS_EXCEL',
  domainId => ({
    domainId
  })
)

export const exportDomainKeywordCompetitorsCSV = Action(
  name + '/EXPORT_DOMAIN_KEYWORD_COMPETITORS_CSV',
  domainId => ({
    domainId
  })
)

export const sortCompetitors = Action(name + '/SORT_COMPETITORS', (domainId, direction, value) => ({
  domainId,
  direction,
  value
}))
